/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Physician
 */
export interface Physician {
    /**
     * 
     * @type {string}
     * @memberof Physician
     */
    physician_name?: string;
    /**
     * 
     * @type {string}
     * @memberof Physician
     */
    date_last_seen?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Physician
     */
    attending_primary_physician?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Physician
     */
    part_of_referral_process?: boolean;
}

/**
 * Check if a given object implements the Physician interface.
 */
export function instanceOfPhysician(value: object): value is Physician {
    return true;
}

export function PhysicianFromJSON(json: any): Physician {
    return PhysicianFromJSONTyped(json, false);
}

export function PhysicianFromJSONTyped(json: any, ignoreDiscriminator: boolean): Physician {
    if (json == null) {
        return json;
    }
    return {
        
        'physician_name': json['physician_name'] == null ? undefined : json['physician_name'],
        'date_last_seen': json['date_last_seen'] == null ? undefined : json['date_last_seen'],
        'attending_primary_physician': json['attending_primary_physician'] == null ? undefined : json['attending_primary_physician'],
        'part_of_referral_process': json['part_of_referral_process'] == null ? undefined : json['part_of_referral_process'],
    };
}

export function PhysicianToJSON(json: any): Physician {
    return PhysicianToJSONTyped(json, false);
}

export function PhysicianToJSONTyped(value?: Physician | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'physician_name': value['physician_name'],
        'date_last_seen': value['date_last_seen'],
        'attending_primary_physician': value['attending_primary_physician'],
        'part_of_referral_process': value['part_of_referral_process'],
    };
}

